import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

import SimpleModal from 'Presentation/Components/Modal/SimpleModal'

interface PromptContextProps {
	showPrompt: boolean
	confirmedNavigation: boolean
	handleShowPrompt: (show: boolean) => void
	handleConfirmedNavigation: (confirmed: boolean) => void
}

export const PromptContext = createContext<PromptContextProps>({
	showPrompt: false,
	confirmedNavigation: false,
	handleShowPrompt: (show: boolean) => {},
	handleConfirmedNavigation: (confirmed: boolean) => {},
})

export const PromptContextProvider: React.FC<WithChildren> = ({ children }) => {
	const [showPrompt, setShowPrompt] = useState<boolean>(false)
	const [confirmedNavigation, setConfirmedNavigation] = useState(false)

	const handleShowPrompt = (show: boolean) => {
		setShowPrompt(show)
	}

	const handleConfirmedNavigation = (confirmed: boolean) => {
		setConfirmedNavigation(confirmed)
	}

	return (
		<PromptContext.Provider
			value={{
				showPrompt,
				confirmedNavigation,
				handleShowPrompt,
				handleConfirmedNavigation,
			}}>
			{children}

			<SimpleModal
				id="prompt-alert-modal"
				size="lg"
				confirmButtonText="Accept"
				cancelButtonText="No"
				show={showPrompt}
				handleClose={() => handleShowPrompt(false)}
				handleConfirm={() => {
					handleShowPrompt(false)
					setConfirmedNavigation(true)
				}}>
				<p>You have unsaved changes, Do you want to discard your changes</p>
			</SimpleModal>
		</PromptContext.Provider>
	)
}
